import { saveAs } from "file-saver";
import adobeLaunchService from "../services/adobeLaunchService.js";

export function createDownload(fileName, csvFileData) {
	adobeLaunchService.trackDownload(fileName, "csv");
	const blob = new Blob(csvFileData, { type: "text/csv" });
	saveAs(blob, `${fileName}.csv`);
}

export function tripleDashNull(value) {
	return value ? value : "---";
}

export function replaceEmDashHtmlEntity(string) {
	const emDashCharSequence = "&#8212;";
	const emDash = "—";
	let newString = string;

	if (string.includes(emDashCharSequence)) {
		newString = string.replace(/&#8212;/gi, emDash);
	}

	return newString;
}
